import {
  createBrowserRouter,
  RouterProvider,
  Route,
  Outlet,
  Routes,
  useLocation,
  MemoryRouter,
  BrowserRouter,
} from "react-router-dom";
import React from "react";
import Navbar from "../components/Navigation/NewHeader";
import SideDrawer from "../components/Navigation/sideNavigation";
import Footer from "../components/Navigation/Footer";
import Dashborad from "../pages/DashboardPages/Dashborad";
import CircularProgress from "@mui/material/CircularProgress";
import ErrorBoundary from "../error/ErrorBoundary";
import LoadingCount from "../utils/constant/loadingCouter";
import { Suspense } from "react";
import SuccessDialog from "../components/BookReservationComponents/SuccessDialog";
import { LocalStorageUtil } from "../utils/LocalStorageUtil";
import { Navigate } from "react-router-dom";
import { AuthGuard } from "./CheckAuth";
const InvitationAccept = React.lazy(
  () => import("../pages/Login/InvitationAccept")
);

const ConsolidatedInvoice = React.lazy(
  () => import("../pages/DashboardPages/ConsolidatedInvoice")
);
const RedirectionPage = React.lazy(() => import("../pages/RedirectionPage"));

const CustomerLogin = React.lazy(() => import("../pages/Staticpages"));
const SignUpPage = React.lazy(() => import("../pages/Login/SignUpPage"));
const LoginPage = React.lazy(() => import("../pages/Login/LoginPage"));
const CompanyDashboard = React.lazy(
  () => import("../pages/DashboardPages/CompanyDashboard")
);
const NewMapDashBoard = React.lazy(
  () => import("../pages/DashboardPages/NewMapDashBoard")
);
const MapDashBoard = React.lazy(
  () => import("../pages/DashboardPages/mapdashboard")
);
const RegistrationPage = React.lazy(
  () => import("../pages/Login/RegistrationPage")
);
const InvoiceDashboard = React.lazy(
  () => import("../pages/DashboardPages/InvoiceDashboard")
);
const SOIDashboard = React.lazy(
  () => import("../pages/DashboardPages/SOIDashboard")
);
const DiscountCodeInvoice = React.lazy(
  () => import("../pages/DashboardPages/DiscountCodeInvoce")
);
const Organizations = React.lazy(
  () => import("../pages/AdminPages/Organizations")
);
const CompanyProfile = React.lazy(
  () => import("../pages/AdminPages/CompanyProfile")
);
const Amenities = React.lazy(() => import("../pages/AdminPages/Amenities"));
const ParkingLot = React.lazy(() => import("../pages/AdminPages/ParkingLot"));
const CarrierOrganization = React.lazy(
  () => import("../pages/CarrierNetwork/CarrierOrganization")
);
const AddCarrier = React.lazy(
  () => import("../pages/CarrierNetwork/AddCarrier")
);
const CarrierAssets = React.lazy(
  () => import("../pages/CarrierNetwork/CarrierAssets")
);
const Payments = React.lazy(() => import("../pages/CarrierNetwork/Payments"));
const ParkingInfo = React.lazy(
  () => import("../components/parkinglotComponent/ParkingInfo")
);
const AddCarrierAsset = React.lazy(
  () => import("../pages/CarrierNetwork/AddCarrierAsset")
);
const BookReservations = React.lazy(
  () => import("../pages/AdminPages/BookReservations")
);
const Assets = React.lazy(() => import("../pages/AdminPages/Assets"));
const AssetType = React.lazy(() => import("../pages/AdminPages/AssetType"));
const Equipment = React.lazy(() => import("../pages/AdminPages/Equipment"));
const Drivers = React.lazy(() => import("../pages/Reports/Drivers"));

const CreateDriver = React.lazy(() => import("../pages/AdminPages/Driver"));
const Reservations = React.lazy(() => import("../pages/Reports/Reservations"));
const Revenue = React.lazy(() => import("../pages/Reports/Revenue"));
const Reconciliation = React.lazy(
  () => import("../pages/Reports/Reconciliation")
);
const SubscriptionReport = React.lazy(
  () => import("../pages/Reports/SubscriptionReport")
);
const AssetReport = React.lazy(() => import("../pages/Reports/AssetReport"));
const ParkingLotReport = React.lazy(
  () => import("../pages/Reports/ParkingLotReport")
);
const ApiHub = React.lazy(() => import("../pages/API/ApiHub"));
const ReservationParkDetails = React.lazy(
  () => import("../pages/Reports/ReservationParkDetails")
);
const ReservationPaymentRetry = React.lazy(
  () => import("../pages/Reports/ReservationPaymentRetry")
);
const ParkinglotPricing = React.lazy(
  () => import("../pages/Reports/ParkinglotPricing")
);
const ParkingLotAccessCode = React.lazy(
  () => import("../pages/AdminPages/ParkingLotAccessCode")
);
const DiscountCode = React.lazy(
  () => import("../pages/AdminPages/DiscountCode")
);

const GlobalDashboard = React.lazy(
  () => import("../pages/Login/GlobalDashboard")
);
const FinAI = React.lazy(() => import("../pages/ChatBot/genAI"));
const FinparkReserve = React.lazy(() => import("../pages/FinparkReserve"));

const ErrorPage = React.lazy(() => import("../pages/errorpage/Errorpage"));

const Layout = () => {
  const location = useLocation();
  return (
    <>
      <Suspense
        fallback={
          <div className="">
            <CircularProgress color="primary" thickness={1} />
          </div>
        }
      >
        <Navbar />
        <SideDrawer />
        <SuccessDialog />
        {location.pathname !== "/globaldashboard" &&
        location.pathname !== "/SignUpPage" ? (
          <div style={{ marginTop: "64px" }}></div>
        ) : (
          ""
        )}
        <LoadingCount />
        <Outlet />
        <Footer />
      </Suspense>
    </>
  );
};

export const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <ErrorBoundary>
        <Suspense>
          <RedirectionPage />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: ":language",
    element: (
      <ErrorBoundary>
        <Suspense>
          <LoginPage />
        </Suspense>
      </ErrorBoundary>
    ),
  },

  {
    path: "/",
    element: (
      <AuthGuard>
        <Layout />
      </AuthGuard>
    ),
    children: [
      {
        path: "/SignUpPage",
        element: (
          <ErrorBoundary>
            <SignUpPage />
          </ErrorBoundary>
        ),
      },
      {
        path: "/LoginPage",
        element: (
          <ErrorBoundary>
            <LoginPage />
          </ErrorBoundary>
        ),
      },
      {
        path: "/dashboard",
        element: (
          <ErrorBoundary>
            <CompanyDashboard />
          </ErrorBoundary>
        ),
      },
      // {
      //   path: "/newMap",
      //   element: (
      //     <ErrorBoundary>
      //       <NewMapDashBoard />
      //     </ErrorBoundary>
      //   ),
      // },
      {
        path: "/acceptInvitation",
        element: (
          <ErrorBoundary>
            <InvitationAccept />
          </ErrorBoundary>
        ),
      },
      {
        path: "/finparkRegistration",
        element: (
          <ErrorBoundary>
            <RegistrationPage />
          </ErrorBoundary>
        ),
      },
      {
        path: "/invoiceDashboard",
        element: (
          <ErrorBoundary>
            <InvoiceDashboard />
          </ErrorBoundary>
        ),
      },
      {
        path: "/soiDashboard",
        element: (
          <ErrorBoundary>
            <SOIDashboard />
          </ErrorBoundary>
        ),
      },
      {
        path: "/consolidatedInvoice",
        element: (
          <ErrorBoundary>
            <ConsolidatedInvoice />
          </ErrorBoundary>
        ),
      },
      {
        path: "/discountcodeinvoice",

        element: (
          <ErrorBoundary>
            <DiscountCodeInvoice />
          </ErrorBoundary>
        ),
      },
      {
        path: "/organizationDetails",
        element: (
          <ErrorBoundary>
            <Organizations />
          </ErrorBoundary>
        ),
      },
      {
        path: "/companyProfile",
        element: (
          <ErrorBoundary>
            <CompanyProfile />
          </ErrorBoundary>
        ),
      },
      {
        path: "/amenities",
        element: (
          <ErrorBoundary>
            <Amenities />
          </ErrorBoundary>
        ),
      },
      {
        path: "/parkingLot",
        element: (
          <ErrorBoundary>
            <ParkingLot />
          </ErrorBoundary>
        ),
      },
      {
        path: "/createDriver",
        element: (
          <ErrorBoundary>
            <CreateDriver />
          </ErrorBoundary>
        ),
      },
      {
        path: "/parkingInfo",
        element: (
          <ErrorBoundary>
            <ParkingInfo />
          </ErrorBoundary>
        ),
      },
      {
        path: "/organizationDetails/editOrganization",
        element: (
          <ErrorBoundary>
            <CompanyProfile />
          </ErrorBoundary>
        ),
      },
      {
        path: `/organizationdetails/:orgId`,
        element: (
          <ErrorBoundary>
            <CompanyProfile />
          </ErrorBoundary>
        ),
      },

      {
        path: "/bookReservations",
        element: (
          <ErrorBoundary>
            <BookReservations />
          </ErrorBoundary>
        ),
      },
      {
        path: "/assets",
        element: (
          <ErrorBoundary>
            <Assets />
          </ErrorBoundary>
        ),
      },
      {
        path: "/assetType",
        element: (
          <ErrorBoundary>
            <AssetType />
          </ErrorBoundary>
        ),
      },
      {
        path: "/equipmentType",
        element: (
          <ErrorBoundary>
            <Equipment />
          </ErrorBoundary>
        ),
      },
      {
        path: "/carrierOrganization",
        element: (
          <ErrorBoundary>
            <CarrierOrganization />
          </ErrorBoundary>
        ),
      },
      {
        path: "/addCarrier",
        element: (
          <ErrorBoundary>
            <AddCarrier />
          </ErrorBoundary>
        ),
      },
      {
        path: "/editCarrierDetails",
        element: (
          <ErrorBoundary>
            <AddCarrier />
          </ErrorBoundary>
        ),
      },
      {
        path: "/carrierAssets",
        element: (
          <ErrorBoundary>
            <CarrierAssets />
          </ErrorBoundary>
        ),
      },
      {
        path: "/sinvoice",
        element: (
          <ErrorBoundary>
            <Payments />
          </ErrorBoundary>
        ),
      },
      {
        path: "/addCarrierAsset",
        element: (
          <ErrorBoundary>
            <AddCarrierAsset />
          </ErrorBoundary>
        ),
      },
      {
        path: "/drivers",
        element: (
          <ErrorBoundary>
            <Drivers />
          </ErrorBoundary>
        ),
      },
      {
        path: "/reservations",
        element: (
          <ErrorBoundary>
            <Reservations />
          </ErrorBoundary>
        ),
      },
      {
        path: "/reservations/:reservationId",
        element: (
          <ErrorBoundary>
            <Reservations />
          </ErrorBoundary>
        ),
      },
      {
        path: "/revenue",
        element: (
          <ErrorBoundary>
            <Revenue />
          </ErrorBoundary>
        ),
      },
      {
        path: "/reconciliation",
        element: (
          <ErrorBoundary>
            <Reconciliation />
          </ErrorBoundary>
        ),
      },
      {
        path: "/subscription",
        element: (
          <ErrorBoundary>
            <SubscriptionReport />
          </ErrorBoundary>
        ),
      },
      {
        path: "/assetReport",
        element: (
          <ErrorBoundary>
            <AssetReport />
          </ErrorBoundary>
        ),
      },
      {
        path: "/parkingLotReport",
        element: (
          <ErrorBoundary>
            <ParkingLotReport />
          </ErrorBoundary>
        ),
      },
      {
        path: "/reservationparkdetails",
        element: (
          <ErrorBoundary>
            <ReservationParkDetails />
          </ErrorBoundary>
        ),
      },
      {
        path: "/reservationparkdetails/:reservationid",
        element: (
          <ErrorBoundary>
            <ReservationParkDetails />
          </ErrorBoundary>
        ),
      },
      {
        path: "/paymentRetry/:reservationid",
        element: (
          <ErrorBoundary>
            <ReservationPaymentRetry />
          </ErrorBoundary>
        ),
      },
      {
        path: "/parkinglotpricing",
        element: (
          <ErrorBoundary>
            <ParkinglotPricing />
          </ErrorBoundary>
        ),
      },
      {
        path: "/parkinglotAccessCode",
        element: (
          <ErrorBoundary>
            <ParkingLotAccessCode />
          </ErrorBoundary>
        ),
      },
      {
        path: "/discountCode",
        element: (
          <ErrorBoundary>
            <DiscountCode />
          </ErrorBoundary>
        ),
      },
      {
        path: "/globaldashboard",
        element: (
          <ErrorBoundary>
            <GlobalDashboard />
          </ErrorBoundary>
        ),
      },
      {
        path: "/reserve",
        element: (
          <ErrorBoundary>
            <FinparkReserve />
          </ErrorBoundary>
        ),
      },
      {
        path: "/apihub",
        element: (
          <ErrorBoundary>
            <ApiHub />
          </ErrorBoundary>
        ),
      },
      {
        path: "/mapDashboard",
        element: (
          <ErrorBoundary>
            <NewMapDashBoard />
          </ErrorBoundary>
        ),
      },
      {
        path: "/finai/*",
        element: (
          <ErrorBoundary>
            <FinAI />
          </ErrorBoundary>
        ),
      },
      {
        path: "*",
        element: <ErrorPage />,
      },
    ],
  },
  {
    path: "/signup",
    element: (
      <ErrorBoundary>
        <Suspense>
          <SignUpPage />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  // {
  //   path: "/mapDashboard",
  //   element: <MapDashBoard />,
  // },
  // {
  //   path: "/invoiceDashboard",
  //   element: <InvoiceDashboard />,
  // },
  // {
  //   path: "/register",
  //   element: <Register />,
  // },
  // {
  //   path: "/login",
  //   element: <Login />,
  // },
]);

// export const AppRouter = () => (
//   <BrowserRouter>
//     <Routes>
//       <Route
//         path="/"
//         element={
//           <ErrorBoundary>
//             <Suspense>
//               <RedirectionPage />
//             </Suspense>
//           </ErrorBoundary>
//         }
//       />
//       <Route
//         path=":language"
//         element={
//           <ErrorBoundary>
//             <Suspense>
//               <LoginPage />
//             </Suspense>
//           </ErrorBoundary>
//         }
//       />
//       <Route path="/*" element={<Layout />}>
//         <Route
//           path="SignUpPage"
//           element={
//             <ErrorBoundary>
//               <SignUpPage />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="LoginPage"
//           element={
//             <ErrorBoundary>
//               <LoginPage />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="dashboard"
//           element={
//             <ErrorBoundary>
//               <CompanyDashboard />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="acceptInvitation"
//           element={
//             <ErrorBoundary>
//               <InvitationAccept />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="finparkRegistration"
//           element={
//             <ErrorBoundary>
//               <RegistrationPage />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="invoiceDashboard"
//           element={
//             <ErrorBoundary>
//               <InvoiceDashboard />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="soiDashboard"
//           element={
//             <ErrorBoundary>
//               <SOIDashboard />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="consolidatedInvoice"
//           element={
//             <ErrorBoundary>
//               <ConsolidatedInvoice />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="discountcodeinvoice"
//           element={
//             <ErrorBoundary>
//               <DiscountCodeInvoice />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="organizationDetails"
//           element={
//             <ErrorBoundary>
//               <Organizations />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="companyProfile"
//           element={
//             <ErrorBoundary>
//               <CompanyProfile />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="amenities"
//           element={
//             <ErrorBoundary>
//               <Amenities />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="parkingLot"
//           element={
//             <ErrorBoundary>
//               <ParkingLot />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="createDriver"
//           element={
//             <ErrorBoundary>
//               <CreateDriver />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="parkingInfo"
//           element={
//             <ErrorBoundary>
//               <ParkingInfo />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="organizationDetails/editOrganization"
//           element={
//             <ErrorBoundary>
//               <CompanyProfile />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="organizationdetails/:orgId"
//           element={
//             <ErrorBoundary>
//               <CompanyProfile />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="bookReservations"
//           element={
//             <ErrorBoundary>
//               <BookReservations />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="assets"
//           element={
//             <ErrorBoundary>
//               <Assets />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="assetType"
//           element={
//             <ErrorBoundary>
//               <AssetType />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="equipmentType"
//           element={
//             <ErrorBoundary>
//               <Equipment />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="carrierOrganization"
//           element={
//             <ErrorBoundary>
//               <CarrierOrganization />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="addCarrier"
//           element={
//             <ErrorBoundary>
//               <AddCarrier />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="carrierAssets"
//           element={
//             <ErrorBoundary>
//               <CarrierAssets />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="sinvoice"
//           element={
//             <ErrorBoundary>
//               <Payments />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="addCarrierAsset"
//           element={
//             <ErrorBoundary>
//               <AddCarrierAsset />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="drivers"
//           element={
//             <ErrorBoundary>
//               <Drivers />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="reservations"
//           element={
//             <ErrorBoundary>
//               <Reservations />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="reservations/:reservationId"
//           element={
//             <ErrorBoundary>
//               <Reservations />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="revenue"
//           element={
//             <ErrorBoundary>
//               <Revenue />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="reconciliation"
//           element={
//             <ErrorBoundary>
//               <Reconciliation />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="subscription"
//           element={
//             <ErrorBoundary>
//               <SubscriptionReport />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="assetReport"
//           element={
//             <ErrorBoundary>
//               <AssetReport />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="parkingLotReport"
//           element={
//             <ErrorBoundary>
//               <ParkingLotReport />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="reservationparkdetails"
//           element={
//             <ErrorBoundary>
//               <ReservationParkDetails />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="reservationparkdetails/:reservationid"
//           element={
//             <ErrorBoundary>
//               <ReservationParkDetails />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="paymentRetry/:reservationid"
//           element={
//             <ErrorBoundary>
//               <ReservationPaymentRetry />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="parkinglotpricing"
//           element={
//             <ErrorBoundary>
//               <ParkinglotPricing />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="parkinglotAccessCode"
//           element={
//             <ErrorBoundary>
//               <ParkingLotAccessCode />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="discountCode"
//           element={
//             <ErrorBoundary>
//               <DiscountCode />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="globaldashboard"
//           element={
//             <ErrorBoundary>
//               <GlobalDashboard />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="reserve"
//           element={
//             <ErrorBoundary>
//               <FinparkReserve />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="apihub"
//           element={
//             <ErrorBoundary>
//               <ApiHub />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="apihub"
//           element={
//             <ErrorBoundary>
//               <ApiHub />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="mapDashboard"
//           element={
//             <ErrorBoundary>
//               <NewMapDashBoard />
//             </ErrorBoundary>
//           }
//         />
//         <Route
//           path="*"
//           element={
//             <ErrorBoundary>
//               <ErrorPage />
//             </ErrorBoundary>
//           }
//         />
//         {/* Add all other routes here without leading slash */}
//       </Route>
//     </Routes>
//   </BrowserRouter>
// );
